/** Contenu AR (arabe standard moderne) de la home — traduction de LANDING_EN. */
import type { LandingData } from "./landingDict";

export const LANDING_AR: LandingData = {
  pageTitle: "تأجير السيارات وسائق خاص في كان | KS Rent Services",
  hero: {
    driverTitle: "الحجز",
    driverDescription: "خدمة سائق خاص راقية لجميع تنقلاتكم المهنية والشخصية",
    driverCta: "احجز الآن",
    rentalTitle: "تأجير السيارات",
    rentalDescription: "أسطول من السيارات الراقية لتلبية كل احتياجات التنقّل",
    rentalCta: "اكتشف سياراتنا",
    driverImageAlt: "خدمة السائق الخاص من KS Rent",
    rentalImageAlt: "تأجير السيارات من KS Rent",
    scrollHint: "مرّر للأسفل",
  },
  clients: {
    heading: "يمنحوننا ثقتهم",
    divider: "عملاؤنا",
    reviewsHeading: "آراء العملاء",
    reviews: [
      {
        quote:
          "مستوى خدمة استثنائي. قضيت أنا والعملاء وقتًا رائعًا، وكانت خدمة العملاء ممتازة.",
        author: "كارين أو. - مديرة أزياء",
      },
      {
        quote:
          "تنسيق لا تشوبه شائبة، وتكتّم مطلق، ودقّة في المواعيد عبر عدة رحلات سرّية.",
        author: "أحد أفراد عائلة مالكة سعودية",
      },
      {
        quote:
          "فريق استباقي، وسيارات في غاية النظافة، وتجربة راقية من أول تواصل حتى نقطة الوصول الأخيرة.",
        author: "مسؤول الشراكات الخاصة بالفعاليات",
      },
    ],
  },
  about: {
    heading: "من نحن",
    intro:
      "منذ عام 2018 ومقرّنا في كان، نرافق الشخصيات العامة والشركات والمسافرين من ذوي الذوق الرفيع في جميع أنحاء الريفييرا الفرنسية. خبرتنا: أسطول راقٍ لا تشوبه شائبة وسائقون منتقَون بعناية لتجربة مصمَّمة بالكامل وفق رغباتكم.",
    cta: "نبذة عن KS Rent Services",
    items: [
      {
        icon: "mdi:star-outline",
        title: "تميّز الخدمة",
        desc: "معايير من فئة 5 نجوم، وبروتوكول استقبال راقٍ، وتكتّم مطلق.",
      },
      {
        icon: "mdi:map-marker-radius-outline",
        title: "كان والريفييرا",
        desc: "نعمل في جميع أنحاء الريفييرا الفرنسية: نيس، موناكو، سان تروبيه…",
      },
      {
        icon: "mdi:steering",
        title: "أسطول راقٍ",
        desc: "سيارات فاخرة تخضع للصيانة والتجهيز من أجل راحتكم.",
      },
    ],
  },
  services: {
    eyebrow: "كان • الريفييرا الفرنسية",
    heading: "مجالا خبرة، ومعيار واحد من التميّز",
    intro:
      "طريقتان للتنقل. مع السائق الخاص، يقودك سائق محترف في سياراتنا: تستمتع بالرحلة ونتولى نحن الطريق والانتظار والأمتعة. ومع تأجير السيارات، تقود بنفسك سيارة فاخرة تُسلَّم إلى العنوان الذي تختاره.",
    driverTitle: "سائق خاص",
    driverBadge: "خدمة 5 نجوم",
    driverLead:
      "خدمة بالساعة، ونقل من وإلى المطارات والمحطات، وفعاليات ورحلات استثنائية. تكتّم ودقّة في المواعيد وراحة مطلقة.",
    driverSub:
      "خدمة تُدار بسائق مخصَّص لتنقلاتكم وفعالياتكم وحجوزاتكم بالساعة.",
    driverItems: ["المطارات والمحطات", "خدمة بالساعة", "الفعاليات", "الشركات"],
    driverCitiesLabel: "حسب المدينة",
    driverCities: [
      "سائق خاص في كان",
      "سائق في أنتيب",
      "سائق في نيس",
      "سائق خاص في موناكو",
      "سائق في سان تروبيه",
    ],
    driverCtaPrimary: "احجز الآن",
    driverCtaSecondary: "اعرف المزيد",
    rentalTitle: "تأجير السيارات",
    rentalBadge: "فخامة ورُقيّ",
    rentalLead:
      "أسطول فاخر، وتوصيل واستلام، وتأمين مصمَّم وفق احتياجكم، ومساندة على مدار الساعة طوال أيام الأسبوع. تجربة الفخامة، خلف المقود.",
    rentalSub:
      "سيارات فاخرة تُسلَّم إليكم لرحلاتكم الخاصة، مع مرافقة مصمَّمة حسب الطلب.",
    rentalItems: [
      "سيارات الرُّقيّ",
      "سيارات الدفع الرباعي والصالون",
      "السيارات المكشوفة",
      "التوصيل والاستلام",
    ],
    rentalCtaPrimary: "اكتشف سياراتنا",
    rentalCtaSecondary: "عرض سعر مخصَّص",
    note: "متوفّر في كان وفي جميع أنحاء الريفييرا الفرنسية. تنسيق الفعاليات، وترتيبات متعددة السيارات، والمتطلّبات الخاصة عند الطلب.",
  },
  gallery: {
    eyebrow: "أسطولنا",
    heading: "معرض السيارات",
    intro:
      "سيارات خارقة أيقونية، وسيارات صالون استثنائية، وسيارات دفع رباعي فاخرة، وسيارات مكشوفة. اكتشف باقة مختارة من السيارات المتاحة للتأجير في جميع أنحاء الريفييرا الفرنسية.",
    bullets: [
      "Rolls Royce & Maybach",
      "Lamborghini & Ferrari",
      "Porsche & Aston Martin",
      "Mercedes & Range Rover",
    ],
    ctaPrimary: "شاهد الأسطول بالكامل",
    ctaSecondary: "طلب خاص",
    prevLabel: "الصورة السابقة",
    nextLabel: "الصورة التالية",
    pauseLabel: "إيقاف مؤقت",
    resumeLabel: "استئناف العرض",
    dotLabel: (n) => `عرض الصورة ${n}`,
    carFallbackAlt: "سيارة",
  },
  excursions: {
    heading: "أكثر رحلاتنا شعبية",
    discover: "اكتشف",
    cardTitles: [
      "نيس، موناكو",
      "كان، غوردون",
      "أنتيب، خوان لي بان",
      "سان تروبيه",
      "مِنتون، الريفييرا الإيطالية",
      "بحيرة سان كاسيان، أخدود فردون",
      "إيز، لا توربي",
      "سان بول دو فانس",
    ],
  },
  enterprise: {
    eyebrow: "مرافقة الشركات",
    heading: "الشركات والفعاليات",
    text: "هل تحتاجون إلى ترتيب مصمَّم حسب الطلب، أو منسِّق، أو عدة سيارات؟ يصمّم فريقنا حلول التنقّل المتكاملة الجاهزة ويتولّى تشغيلها بالكامل.",
    ctaContact: "تواصل معنا",
    ctaReserve: "احجز سائقًا",
  },
  valueProps: {
    eyebrow: "خيار العملاء الأكثر تطلّبًا",
    heading: "وعد KS Rent Services",
    intro:
      "خدمات مصمَّمة للشخصيات العامة والوكلاء والشركات: مرونة وأمان وتميّز في الخدمة.",
    reviewsEyebrow: "آراء عملاء مجهولة الهوية",
    googleEyebrow: "تقييمات Google",
    googleNote: "تميّز يؤكّده عملاء من ذوي المتطلّبات العالية.",
    catalogueLabel: "الكتالوج",
    modelsAvailable: (n) => `أكثر من ${n} طرازًا متاحًا`,
    reviews: [
      {
        quote: "تنسيق راقٍ على مدى عدة أيام، دون أي عقبات تشغيلية.",
        source: "دار أزياء (مجهولة الهوية)",
        tag: "التنسيق",
      },
      {
        quote: "دقّة ثابتة في المواعيد وتنفيذ لا تشوبه شائبة في كل عملية نقل.",
        source: "إدارة دولية (مجهولة الهوية)",
        tag: "دقّة المواعيد",
      },
      {
        quote: "تكتّم تام، وجودة سيارات مثالية، وفريق سريع الاستجابة للغاية.",
        source: "شخصية مهمّة (مجهولة الهوية)",
        tag: "التكتّم",
      },
      {
        quote: "إدارة لوجستية محكمة حتى في ظل جداول زمنية ضيّقة.",
        source: "وكالة فعاليات (مجهولة الهوية)",
        tag: "الخدمات اللوجستية",
      },
    ],
    cards: [
      {
        title: "دفع ميسَّر",
        description: "بطاقة وتحويل ودفع للشركات. تأكيد سريع.",
        label: "الدفع",
      },
      {
        title: "متاحون على مدار الساعة طوال الأسبوع",
        description: "مساندة متواصلة، وردّ سريع، ومتابعة فورية.",
        label: "الدعم",
      },
      {
        title: "رضا بنسبة 100%",
        description:
          "آراء علامات تجارية وعملاء من ذوي المتطلّبات العالية، بصيغة مجهولة الهوية.",
        label: "التجربة",
      },
      {
        title: "أسطول الرُّقيّ",
        description: "سيارات صالون ودفع رباعي ومكشوفة — معايير رفيعة.",
        label: "السيارات",
      },
      {
        title: "الفعاليات",
        description: "تنسيق متعدد السيارات وترتيبات لكبار الشخصيات.",
        label: "العمليات",
      },
      {
        title: "التكتّم والأمان",
        description: "بروتوكولات صارمة وسرّية تامة.",
        label: "الثقة",
      },
    ],
    fleetAlt: "أسطول KS Rent Services",
    eventsAlt: "أجواء فعالية",
  },
  universe: {
    heading: "عالم KS Rent Services",
    intro:
      "سائق خاص، ولحظات مع العملاء، وعالم الأسطول: لمحة فورية عن معايير خدمتنا على الريفييرا.",
    brandFilmAlt:
      "الفيلم التعريفي لعلامة KS Rent Services مع سائق خاص وأسطول فاخر",
    socialProofAlt: "أجواء مع العملاء وخدمة فاخرة من KS Rent Services",
    fleetUniverseAlt: "عالم الأسطول الفاخر من KS Rent Services",
  },
  orient: {
    heading: "وجِّه طلبك في الاتجاه الصحيح",
    links: [
      { label: "احجز سائقًا", frPath: "/chauffeur" },
      { label: "استكشف الرحلات الخاصة", frPath: "/excursions" },
      {
        label: "استأجر سيارة",
        frPath: "/location/vehicules#catalogue-location",
      },
      { label: "طلب سريع", frPath: "/reservation" },
    ],
  },
};
